import type { ConceptDef } from '../types';

export const mandChoice: ConceptDef = {
  kind: 'supervisorScored',
  id: 'mand-choice',
  label: 'Mand Choice',
  category: 'Mand',
  description: 'Offer two items; learner names the preferred one. Supervisor scores.',
  config: {
    promptMode: 'TEXT',
    prompts: [
      { prompt: '🧃 juice  or  💧 water', hint: 'Learner picks and names it' },
      { prompt: '🍪 cookie  or  🍎 apple' },
      { prompt: '🚗 red car  or  🚙 blue car' },
      { prompt: '⚽ ball  or  🧸 teddy' },
      { prompt: '📕 book  or  🎨 crayons' },
    ],
  },
};
